import { SelectOption } from '../models';

export enum VehicleStateEnum {
  ASSIGNED = 'Assigned',
  UNASSIGNED = 'Unassigned',
  RESERVED = 'Reserved',
}

export const VehicleState: SelectOption[] = [
  { value: VehicleStateEnum.ASSIGNED, label: 'Assigned' },
  { value: VehicleStateEnum.UNASSIGNED, label: 'Unassigned' },
  { value: VehicleStateEnum.RESERVED, label: 'Reserved' },
];
